import {
  addInseamsToGraphBidirectionally,
  addInseamsToMap,
} from "../../utils/price-consolidation";

export const SET_PRODUCT = "SET_PRODUCT";
export const UPDATE_INSEAMS_GRAPH = "UPDATE_INSEAMS_GRAPH";

export const setProduct = () => (dispatch) => {
  dispatch({
    type: SET_PRODUCT,
    payload: {
      // @TODO: NCE-653 Populate new Redux store with shared data
    },
  });
};

/**
 * Updates Graph and Map in store.
 * @param {Array} linkedInseamsList List of productIds with their linked inseams: shape { productId: string, linkedInseams: Array }
 * @param {String} linkedInseamsList[].productId The PDP productId.
 * @param {Array} linkedInseamsList[].linkedInseams Array of: shape { inseam: string, productId: string, productUrl: string }
 */
export const updateInseamsGraph =
  (linkedInseamsList) => (dispatch, getState) => {
    if (!linkedInseamsList?.length) {
      return;
    }

    const state = getState?.() || {};
    const pdpReducer = state?.rootReducer?.productDetailPage || {};

    const initialGraphAndMap = {
      inseamsGraph: new Map(pdpReducer.inseamsGraph),
      productIdToInseamMap: new Map(pdpReducer.productIdToInseamMap),
    };

    const newGraphAndMap = linkedInseamsList.reduce(
      (acc, { productId, linkedInseams }) => {
        acc.productIdToInseamMap = addInseamsToMap(
          linkedInseams,
          acc.productIdToInseamMap
        );
        acc.inseamsGraph = addInseamsToGraphBidirectionally(
          productId,
          linkedInseams,
          acc.inseamsGraph
        );
        return acc;
      },
      initialGraphAndMap
    );

    dispatch({
      type: UPDATE_INSEAMS_GRAPH,
      payload: newGraphAndMap,
    });
  };

export const setLoadedInseams = async (dispatch, loadInseamPromises) => {
  const loadInseamSettled = await Promise.allSettled(loadInseamPromises);

  const loadedInseamsList = loadInseamSettled?.reduce(
    (acc, { status, value }) => {
      if (status === "fulfilled" && value) {
        const markdownConsolidatedData =
          value.data?.productDetailPageData?.markdownConsolidated;
        if (markdownConsolidatedData) {
          acc.push({
            productId: markdownConsolidatedData.productSummary?.productId,
            linkedInseams: markdownConsolidatedData.allInseam,
          });
        }
      }
      return acc;
    },
    []
  );

  dispatch(updateInseamsGraph(loadedInseamsList));
};
